import React from 'react';
import { ResetPasswordDataContext } from './context';
import { useRoutingData } from '../routing/hooks';
import CoreClient from '@c42/core-client';
import Text from '../../../../shared/Text';
import { useHistory } from 'react-router';
import { LOGIN_INDEX } from '../../../constants/routes';
import { useResetForm } from '../auth/hooks';

export const useResetPasswordData = () => React.useContext(ResetPasswordDataContext).resetPasswordData;

export const useSetResetPasswordData = () => React.useContext(ResetPasswordDataContext).setResetPasswordData;

export const useOnSubmitPasswordReset = () => {
  const history = useHistory();
  const routingData = useRoutingData();
  const setResetPasswordData = useSetResetPasswordData();

  return (password: string) => {
    setResetPasswordData((current) => ({
      ...current,
      isUpdatingPassword: true,
      notification: null,
      error: null,
    }));
    const params = {
      token: routingData.passwordResetTokenParam,
      password,
    };

    return CoreClient.UserPasswordResetUpdate.update({ params, useCache: false }).then(
      () => {
        setResetPasswordData((current) => ({
          ...current,
          isUpdatingPassword: false,
          notification: Text.get('login_password_reset_success'),
          error: null,
        }));
        history.push(LOGIN_INDEX);
      },
      (error) => {
        if (error?.responseJson?.[0]?.name === 'INVALID_TOKEN') {
          setResetPasswordData((current) => ({
            ...current,
            isUpdatingPassword: false,
            notification: null,
            error: Text.get('login_password_reset_invalid_token'),
          }));
        } else {
          setResetPasswordData((current) => ({
            ...current,
            isUpdatingPassword: false,
            notification: null,
            error: Text.get('login_password_reset_error'),
          }));
        }
      },
    );
  };
};

export const useOnRequestPasswordReset = () => {
  const setResetPasswordData = useSetResetPasswordData();
  const resetForm = useResetForm();

  return (username: string) => {
    setResetPasswordData((current) => ({
      ...current,
      isCreatingPasswordReset: true,
      notification: null,
      error: null,
    }));
    const params = { username };

    return CoreClient.UserPasswordResetRequest.create({ params, useCache: false }).then(
      () => {
        setResetPasswordData((current) => ({
          ...current,
          isCreatingPasswordReset: false,
          notification: Text.get('_flash_password_reset_check_email'),
          error: null,
        }));
        resetForm();
      },
      () => {
        setResetPasswordData((current) => ({
          ...current,
          isCreatingPasswordReset: false,
          notification: null,
          error: null,
        }));
        resetForm();
      },
    );
  };
};
